import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectLegacyBaseUrl } from '~/store';
import { routerLocationShape, routerMatchShape } from '../helpers/propTypeShapes';
import '../style/apps.css';
import Admin from './Admin';

const Apps = ({ checkAuthorization, location, match, reAuth, trackEvent }) => {
  const legacyBaseUrl = useSelector(selectLegacyBaseUrl);

  useEffect(() => {
    checkAuthorization('apps');
  }, [checkAuthorization]);

  return (
    <div className="apps-content">
      <Admin
        checkAuthorization={checkAuthorization}
        iframeSrc={`${legacyBaseUrl}/downloads.php`}
        location={location}
        match={match}
        reAuth={reAuth}
        trackEvent={trackEvent}
      />
    </div>
  );
};

Apps.propTypes = {
  checkAuthorization: PropTypes.func.isRequired,
  location: routerLocationShape.isRequired,
  match: routerMatchShape.isRequired,
  reAuth: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

export default Apps;
